import styled from 'styled-components';

import { Card } from '@xing-com/card';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  cornerRadiusXL,
  spaceXS,
  spaceS,
  spaceM,
  spaceL,
  spaceXXL,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

export const StyledAnchor = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

export const StyledCard = styled(Card)<{ backgroundColor: string }>`
  border-radius: ${cornerRadiusXL};
  border: 0;
  background-color: ${(props) => props.backgroundColor};
  height: 100%;
  margin-bottom: calc(${spaceL} + ${spaceXS});
  min-height: 220px;
  justify-content: flex-start;
  width: 100%;

  @media ${mediaConfined} {
    margin-bottom: 0;
    min-height: 262px;
  }
`;

export const StyledIconWrapper = styled.span<{ backgroundColor: string }>`
  margin-bottom: ${spaceXXL};

  & svg {
    color: ${({ backgroundColor }) => backgroundColor};
  }

  @media ${mediaConfined} {
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledHeadline = styled(Headline)<{ textColor: string }>`
  color: ${(props) => props.textColor};
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    margin-bottom: ${spaceM};
  }
`;

export const StyledBodyCopy = styled(BodyCopy)<{ textColor: string }>`
  color: ${(props) => props.textColor};
`;
